import React, { useContext, useState, useEffect } from "react"
import {
  FaAngleUp,
  FaAngleDown,
  FiVolumeX,
  // FiVolume2,
  FaPlay,
  FaPause,
  FaTimes,
  IoMdAdd,
  IoMdRemove,
  RiLoaderLine,
  RiMusicLine,
  RiRepeatLine,
} from "react-icons/all"
import { AudioContext } from "../context/audioContext"

const PlayAudio = () => {
  // states
  const [music, setMusic] = useContext(AudioContext)
  const [minimize, setMinimize] = useState(false)
  const [close, setClose] = useState(false)
  const [playing, setPlaying] = useState(true)
  const [volume, setVolume] = useState(80)
  const [mute, setMute] = useState(false)
  const [isLoop, setLoop] = useState(false)
  const [volumeRevealed, setVolumeRevealed] = useState(false)
  const [currentTimeInSec, setCurrentTimeInSec] = useState(0)
  const [currentTimeInMin, setCurrentTimeInMin] = useState(0)
  const [songDurationInSec, setSongDurationInSec] = useState(0)
  const [songDurationInMin, setSongDurationInMin] = useState(0)
  const [currentTime, setCurrentTime] = useState(0)
  const [songDuration, setSongDuration] = useState(0)
  const [isBuffering, setBuffering] = useState(false)

  const audio = document.getElementsByTagName("audio")

  const playPause = () => {
    if (audio) {
      if (audio[0].paused) {
        audio[0].play()
        setPlaying(true)
        setMusic({
          ...music,
          currentPlaying: {
            musicId: music.id,
            isPlaying: true,
          },
        })
      } else {
        audio[0].pause()
        setPlaying(false)
        setMusic({
          ...music,
          currentPlaying: {
            musicId: music.id,
            isPlaying: false,
          },
        })
      }
    } else {
      setPlaying(playing)
    }
  }

  const autoLoop = () => {
    setLoop(!isLoop)
  }

  const muteAudio = () => {
    if (audio) {
      setMute(!mute)
      audio[0].muted = !mute
    } else {
      setMute(mute)
    }
  }

  const revealVolumeController = () => {
    setVolumeRevealed(!volumeRevealed)
  }

  const changeProgressBar = (e) => {
    let { value } = e.target
    setCurrentTime(value)
    if (audio) {
      audio[0].currentTime = value
    }
  }

  const handleVolumeChange = (e) => {
    let { value } = e.target
    setVolume(value)
    setMute(false)
    if (audio) {
      if (mute) {
        audio[0].muted = false
      }
      audio[0].volume = volume / 100
    }
  }

  const volumeUp = () => {
    setMute(false)
    if (audio) {
      if (mute) {
        audio[0].muted = false
      }
      setVolume((currentVolume) => {
        let volumeInt = parseInt(currentVolume, 10)
        if (volumeInt <= 89) {
          audio[0].volume = (volumeInt + 10) / 100
          return volumeInt + 10
        } else {
          audio[0].volume = 99 / 100
          return 99
        }
      })
    }
  }

  const volumeDown = () => {
    setMute(false)
    if (audio) {
      if (mute) {
        audio[0].muted = false
      }
      setVolume((currentVolume) => {
        let volumeInt = parseInt(currentVolume, 10)
        if (volumeInt >= 10) {
          audio[0].volume = (volumeInt - 10) / 100
          return volumeInt - 10
        } else {
          audio[0].volume = 0
          return 0
        }
      })
    }
  }

  // setting/updating states
  const changeState = () => {
    setMinimize(!minimize)
  }

  const closeAudio = () => {
    setClose(true)
    audio[0].pause()
    setCurrentTime(0)
    setSongDuration(0)
    setCurrentTimeInMin(0)
    setMinimize(false)
    setMusic({
      ...music,
      id: "",
      src: "",
      title: "",
      type: "",
      currentPlaying: {
        musicId: "",
        isPlaying: false,
      },
    })
  }

  useEffect(() => {
    if (audio && audio.length > 0) {
      audio[0].onBuffer = () => {
        setBuffering(true)
      }
      audio[0].onPlay = () => {
        setBuffering(false)
      }
      audio[0].onloadeddata = () => {
        audio[0].play()
        audio[0].volume = volume / 100
        setPlaying(true)
        setMusic({
          ...music,
          currentPlaying: {
            musicId: music.id,
            isPlaying: true,
          },
        })
        setCurrentTimeInSec(parseInt(audio[0].currentTime) % 60)
        setCurrentTimeInMin(parseInt((audio[0].currentTime / 60) % 60))
        setSongDurationInSec(parseInt(audio[0].duration) % 60)
        setSongDurationInMin(parseInt((audio[0].duration / 60) % 60))
        setSongDuration(audio[0].duration)
        setCurrentTime(audio[0].currentTime)
      }
      audio[0].ontimeupdate = () => {
        if (audio[0] && audio[0].currentTime) {
          setCurrentTimeInSec(parseInt(audio[0].currentTime) % 60)
          setCurrentTimeInMin(parseInt((audio[0].currentTime / 60) % 60))
          setCurrentTime(audio[0].currentTime)
        }
        if (audio[0] && audio[0].duration) {
          setSongDurationInSec(parseInt(audio[0].duration) % 60)
          setSongDurationInMin(parseInt((audio[0].duration / 60) % 60))
          setSongDuration(audio[0].duration)
        }
      }
      audio[0].onended = () => {
        setCurrentTime(0)
        setCurrentTimeInSec(0)
        setCurrentTimeInMin(0)
        setPlaying(false)
        setMusic({
          ...music,
          currentPlaying: {
            musicId: music.id,
            isPlaying: false,
          },
        })
      }
    }
  })

  return (
    <div className={close ? "player player-closed" : "player"}>
      {music && music.src && music.title ? (
        <div
          className={
            minimize ? `audio-player minimal-audio-player` : `audio-player`
          }
        >
          <div className="container-controllers">
            <span onClick={changeState}>
              {minimize ? (
                <FaAngleUp className="icon" />
              ) : (
                <FaAngleDown className="icon" />
              )}
            </span>
            <span onClick={closeAudio}>
              <FaTimes className="icon" />
            </span>
          </div>
          {music.cover && (
            <div className="image-container">
              <img
                src={`https://via.placeholder.com/100x100.png?text=${music.cover}`}
                alt={`${music.title} cover`}
              />
            </div>
          )}
          <h2>{music.title}</h2>
          <div
            className={
              volumeRevealed
                ? "volume-controllers volume-revealed"
                : "volume-controllers"
            }
          >
            <span className={mute ? "mute-audio" : ""} onClick={muteAudio}>
              <FiVolumeX className="icon" />
            </span>
            <span onClick={volumeDown}>
              <IoMdRemove className="icon" />
            </span>
            <input
              type="range"
              value={volume && volume}
              step={10}
              min={0}
              max={100}
              onChange={(e) => handleVolumeChange(e)}
            />
            <span onClick={volumeUp}>
              <IoMdAdd className="icon" />
            </span>
          </div>
          <div className="audio-controllers">
            <span className="play-pause" onClick={playPause}>
              {playing ? (
                <FaPause className="icon" />
              ) : (
                <FaPlay className="icon" />
              )}
            </span>
            <span
              onClick={autoLoop}
              className={isLoop ? "loop" : "loop no-loop"}
            >
              <RiRepeatLine className="icon" />
            </span>
            <span
              className={
                volumeRevealed ? "volume volume-revealed-btn" : "volume"
              }
              onClick={revealVolumeController}
            >
              <RiMusicLine className="icon" />
            </span>
          </div>
          <div className="progress-box">
            <div className="progress">
              <input
                type="range"
                className="progress-bar"
                id="progress"
                value={currentTime && currentTime}
                max={songDuration && songDuration}
                onChange={(e) => changeProgressBar(e)}
              />
              {isBuffering && <RiLoaderLine className="icon" />}
            </div>
            <div className="dur">
              <span className="current-dur">
                {currentTimeInMin}:
                {currentTimeInSec < 10
                  ? `0${currentTimeInSec}`
                  : `${currentTimeInSec}`}
              </span>
              <span className="song-dur">
                {songDurationInMin}:
                {songDurationInSec < 10
                  ? `0${songDurationInSec}`
                  : `${songDurationInSec}`}
              </span>
            </div>
          </div>
          <div className="purchase">
            <button>Buy This Beat</button>
          </div>
          <audio
            key={music.src}
            id="myAudio"
            controlsList="nodownload"
            loop={isLoop}
          >
            <source src={music.src} type={music.type} />
            Your Browser does not support this audio format
          </audio>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}

export default PlayAudio
